<template>
  <section>
    <b-card class="mb-1 sticky-top" style="height: 58px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="10">
          <b-row class="d-flex align-items-center justify-content-start">
            <span class="bg-primary round text-white ml-2" style="width: 80px; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">기간</span>
            <flat-pickr
              class="form-control border-1"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              :config="configs.monthSelect" 
              :value="form.monthSelect"
              placeholder="YYYY-MM ~ YYYY-MM"
              @on-open="datePickerOnOpen"
              @on-change="datePickerOnChange"
              @on-close="datepickerCloseHandler"
            />
            <span class="bg-primary round text-white ml-5" style="width: 80px; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">조건</span>
            
            <vue-select
              class="major-class"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              label="title"            
              :options="firstClassList"
              :clearable="true"
              v-model="selectedFirstClass"
              placeholder="대분류(전체)"
            >
            </vue-select>

            <vue-select
              class="middle-class mr-5"
              label="middle"            
              :options="middleClassList"
              :clearable="true"
              v-model="selectedMiddleClass"
              placeholder="중분류(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
            >
              <template v-slot:no-options >
                <em style="opacity: 0.5; font-size: 12px;">대분류 항목을 선택하세요.</em>
              </template>
            </vue-select>
            
            <v-divider
              thickness="10"
              class="border-opacity-100"
              style="border-width: 1.2px; margin-top: 3px; margin-bottom: 1px; border-color: #d8d6de;"
              vertical
            />

            <b-button class="ml-5" id="analysis" style="height: 28px; width: 80px; padding: 0.5rem 0.85rem; margin-left: 5px;" @click="runAnalysis">
              분석하기
            </b-button>
          </b-row>                   
        </b-col>
        <b-col cols="2">
          <b-row class="d-flex align-items-center justify-content-end">
            <b-button id="exp_pdf" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToPDF">
              <div v-if="isPdfExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-pdf fa-lg"/>
              </div>
            </b-button>
            <b-tooltip target="exp_pdf" triggers="hover"> Export to PDF </b-tooltip>
            <b-button id="exp_xls" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToExcel">
              <div v-if="isXlsExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-excel fa-lg"/>
              </div>
            </b-button>    
            <b-tooltip target="exp_xls" triggers="hover"> Export to Excel </b-tooltip>
          </b-row>
        </b-col>
      </b-row>
    </b-card>


    <!-- <b-card class="mb-1 sticky-top" style="height: 58px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body>
      <b-row style="margin-top: 0px;">
        <b-col xl="1" md="1" sm="1">
          <b-row class="d-flex align-items-center justify-content-center">
            <span class="bg-secondary round text-white ml-2 mt-1" style="width: 100%; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">기간</span>
          </b-row>
        </b-col>
        <b-col xl="2" md="2" sm="2">
          <b-row class="d-flex align-items-center justify-content-start">
            <flat-pickr
              class="form-control border-1"
              style="height: 32px; width: 200px; text-align: center; font-size: 14px; margin-left: 5px;"
              :config="configs.monthSelect" 
              :value="form.monthSelect"
              placeholder="YYYY-MM ~ YYYY-MM"
              @on-open="datePickerOnOpen"
              @on-change="datePickerOnChange"
              @on-close="datepickerCloseHandler"
            />
          </b-row>
        </b-col>
        <b-col xl="1" md="1" sm="1">
          <b-row class="d-flex align-items-center justify-content-center">
            <span class="bg-secondary round text-white ml-2 mt-1" style="width: 100%; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">조건</span>
          </b-row>
        </b-col>
        <b-col xl="2" md="2" sm="2" class="d-flex align-items-start" style="margin-top: -3px;">
          <b-row class="d-flex align-items-center justify-content-start">
            <vue-select
              class="first-class mr-3"
              style="height: 32px; width: 200px; text-align: center; font-size: 14px; margin-left: 5px;"
              label="title"            
              :options="firstClassList"
              :clearable="true"
              v-model="selectedFirstClass"
              placeholder="대분류(전체)"
            >
            </vue-select>
          </b-row>
        </b-col>
        <b-col xl="2" md="2" sm="2" class="d-flex align-items-start" style="margin-top: -3px; margin-left: -4rem;">
          <b-row class="d-flex align-items-center justify-content-start">
            <vue-select
              class="middle-class mr-3"
              style="height: 32px; width: 200px; text-align: center; font-size: 14px; margin-left: 5px;"
              label="middle"            
              :options="middleClassList"
              :clearable="true"
              v-model="selectedMiddleClass"
              placeholder="중분류(전체)"
            >
            </vue-select>
          </b-row>
        </b-col>
        <b-col xl="2" md="2" sm="2">
          <b-row class="d-flex align-items-center justify-content-start">
          <b-button class="ml-5" id="analysis" style="height: 28px; width: 80px; padding: 0.5rem 0.85rem; margin-left: 5px;" @click="runAnalysis">
            분석하기
          </b-button>
          </b-row>
        </b-col>
        <b-col xl="2" md="2" sm="2" style="margin-left: 4rem;">
          <b-row class="d-flex align-items-center justify-content-end">
            <b-button id="exp_pdf" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToPDF">
              <div v-if="isPdfExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-pdf fa-lg"/>
              </div>
            </b-button>
            <b-tooltip target="exp_pdf" triggers="hover"> Export to PDF </b-tooltip>
            <b-button id="exp_xls" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToExcel">
                <div v-if="isXlsExporting" class="spinner-border spinner-border-sm"></div>
                <div v-else>
                  <i class="fa-regular fa-file-excel fa-lg"/>
                </div>
            </b-button>    
          </b-row>
        </b-col>
      </b-row>
    </b-card> -->

    <b-card class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="5" style="text-align: left; color:whitesmoke; font-size: 14px; margin-left: 1.0rem; padding: 5px; background-color:lightslategray; border-radius: 5px;">
          💡 각 브랜드 별로, 소비자가 기억하고 관심을 가지는 연결고리를 볼 수 있습니다.
        </b-col>
      </b-row>
      <b-row style="margin-top: 10px;">
        <b-col  xl="2" md="2" sm="2">
           <b-form-group>
            <b-form-radio-group id="radio-group" v-model="selectedChart" buttons size="sm">
              <b-form-radio class="chart-radio" value="net" button @change="changeChart('net')" style="display: block !important; margin: 1px 1px;">
                <feather-icon icon="Share2Icon" size="16" style="margin-bottom: 1px;"/>
              </b-form-radio>
              <b-form-radio class="chart-radio" value="bar" button @change="changeChart('bar')" style="display: block !important; margin: 1px 1px;">
                <feather-icon icon="BarChart2Icon" size="16" style="margin-top: 1px; transform: rotate( 90deg );"/>
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
        <b-col xl="10" md="10" sm="10">
          <div style="width: 100%; text-align: center; margin-left: -12rem;">
            <h2 style="margin-bottom: 0rem;">SEARCH TAG</h2>
          </div>
        </b-col>
      </b-row>
      
      <b-row>
        <b-col xl="2" md="2" sm="2">
          <vue-select
            class="select-brand"
            label="title"            
            :options="brandList"
            :clearable="true"
            v-model="selectedBrand1"
            placeholder="브랜드(전체)"
          >
          </vue-select>
        </b-col>
        <b-col xl="1" md="1" sm="1">
        </b-col>
        <b-col xl="6" md="6" sm="6">
          <div style="width: 100%; text-align: center; margin-top: 0rem; color: #ea5455; margin-left: -2rem;">            
            📢 그래프의 특정 TAG를 선택하시면 하단의 검색량 상위 키워드가 변경됩니다.
          </div>
          <!-- <div style="width: 100%; text-align: center; margin-top: 0rem; color: #ea5455; margin-left: -2rem;">            
            📢 그래프 또는 TAG 순위에서 특정 TAG를 선택하시면 하단의 검색량 상위 키워드가 변경됩니다.
          </div> -->
        </b-col>
        <b-col xl="2" md="2" sm="2">
        </b-col>
      </b-row>
      
      <b-row ref="bntPrintArea1" style="margin-top: 0px;">
        <b-col xl="2" md="2" sm="2" style="margin-left: 1rem;">
          <b-row>
            <b-col>
              <b-form-radio-group
                id="radio-group-1"
                v-model="selectedRadio"
                :options="radioOptions"
                name="radio-options"
                style="margin-top: 1rem;"
              ></b-form-radio-group>
            </b-col>
          </b-row>
          <b-row class="sideMenu">
            <b-col>
              <div>
                <b-row>
                  <b-col>
                    <h3 style="text-align: center;">구분</h3>
                  </b-col>
                </b-row>
                <b-row class="sideMenuInner">
                  <b-col style="position: relative;">
                    <div id="loadingGubun" class="text-center text-primary my-2" style="position: absolute; top: 350%; left: 40%; visibility: visible;">
                      <b-spinner class="align-middle mr-2"></b-spinner>
                      <strong>분석중...</strong>
                    </div>
                    <div>
                      <b-form-group>
                        <template #label>
                          <b-form-checkbox
                            id="gubunTotal"
                            v-model="allSelected"
                            :indeterminate="indeterminate"
                            aria-describedby="gubuns"
                            aria-controls="gubuns"
                            @change="toggleAll"
                          >
                            {{ allSelected ? '전체 선택 해제' : '전체 선택' }}
                          </b-form-checkbox>
                        </template>
                        <ul id="checkbox">
                          <li v-for="object in gubunsObjects" :key="object.value" style="list-style-type: none; margin-top: 1rem;">
                            <b-form-checkbox
                              v-model="selectedGubuns"
                              label="체크박스"
                              :id="object.type"
                              :value="object.value"
                              >
                              {{ object.value }}
                            </b-form-checkbox>
                          </li>
                        </ul>
                      </b-form-group>
                    </div>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-button id="filter_btn" style="height: auto; width: 100%; padding: 0.6rem 0.85rem; margin-right: 5px; margin-top: 1rem;" @click="loadData">
                      <div>
                        적용하기
                      </div>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          
          
          

        </b-col>
        <b-col id="chartCol" xl="6" md="6" sm="6" style="position: relative; min-height: 600px;">
          <!-- <div id="spinner"></div> -->
          <div id="loadingStack" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>분석중...</strong>
          </div>
          <div id="brandpinBarCol1" style="position: absolute; margin-left: 0rem; margin-top: 1rem; visibility: hidden;">
            <!-- <b-row style="margin-top: 0.5rem; margin-bottom: 1rem;">
              <b-col>
                <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #FFB777; vertical-align: middle; margin-left: 1.5rem;"></div>
                <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">라인인 브랜드</div>
                
                <div style="display: inline-block; width: 2rem; height: 1rem; background-color: #FF7070; vertical-align: middle; margin-left: 1.5rem;"></div>
                <div style="display: inline-block; vertical-align: middle; margin-left: 0.5rem;">상품명</div>
              </b-col>
            </b-row> -->
            <div class="graphic-container">
              <brand-name-tag-chart-bar
                :height="height"
                :barChartData="barChartData1"
                :barChartFreq="barChartFreq1"
                :barChartSub="barChartSub1"
                :barChartSubTitle="barChartSubTitle1"
                :barChartCategory="barChartCategory1"
                :barChartColor="barChartColor1"
                :totalFreq="totalFreq1"
                :isChartInit="barChartInit1"
                :selectedNode="selectedNode"
                :whichChart="whichChart"
                :barLoadEnd="barLoadEnd"
              />
            </div>
          </div>


          <div id="brandpinNetRow1L" ref="brandpinNetRow1L" style="position: absolute; margin-left: 0rem;">
            <div class="graphic-container" style="margin-top: 0.5rem;">
              <brand-name-tag-chart-net2 
              :netChartNodes="netChartNodesSubBrand1"
              :netChartLinks="netChartLinksSubBrand1"
              :whichChart="whichChart"
              />
            </div>
            <!-- <div v-if="this.netChartNodesSubBrand1.length > 1" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-top: 5px; margin-bottom: 5px;">          
              <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
                <div v-if="this.selectedBrand1 != null" style="margin-bottom: 4px;">
                  <div v-if="this.netChartNodesSubBrand1.length == 2">
                    • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b> 를 가장 많이 검색되었습니다.
                  </div>
                  <div v-else-if="this.netChartNodesSubBrand1.length == 3">
                    • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand1[2].id }}</b> 순서로 가장 많이 검색되었습니다.
                  </div>
                  <div v-else-if="this.netChartNodesSubBrand1.length > 3">
                    • 소비자들은 <b>{{ this.selectedBrand1 }}</b>의 라인인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand1[2].id }}</b>, 🥉<b>{{ this.netChartNodesSubBrand1[3].id }}</b> 순서로 가장 많이 검색되었습니다.
                  </div>
                </div>
                <div v-else style="margin-bottom: 4px;">
                  <div v-if="this.netChartNodesSubBrand1.length == 2">
                    • 소비자들은 <b>전체</b> 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b> 를 가장 많이 검색되었습니다.
                  </div>
                  <div v-else-if="this.netChartNodesSubBrand1.length == 3">
                    • 소비자들은 <b>전체</b> 라인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand1[2].id }}</b> 순서로 가장 많이 검색되었습니다.
                  </div>
                  <div v-else-if="this.netChartNodesSubBrand1.length > 3">
                    • 소비자들은 <b>전체</b> 라인인브랜드에 대해 총 <b>{{ this.netChartNodesSubBrand1[0].freq.toLocaleString() }}</b>건의 검색량이 발생하였으며, 🥇<b>{{ this.netChartNodesSubBrand1[1].id }}</b>, 🥈<b>{{ this.netChartNodesSubBrand1[2].id }}</b>, 🥉<b>{{ this.netChartNodesSubBrand1[3].id }}</b> 순서로 가장 많이 검색되었습니다.
                  </div>
                </div>
                <div style="color: #1951dc;">
                  👉 위 키워드들은 소비자가 브랜드를 무엇으로 기억하고 있는지 보여줍니다.
                </div>
              </div>
            </div> -->
          </div>


        </b-col>
        <b-col xl="4" md="4" sm="4" style="margin-left: -1rem;">
          <b-row>
            <b-col style="text-align: center; font-size: 2rem;">
              <h3>TAG 순위</h3>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col style="text-align: center; color: #6B6B6B; margin-bottom: 0.5rem;">
              {{ this.mapHistory.toUpperCase() }}
            </b-col>
          </b-row> -->
          <b-row>
            <b-col style="padding-left: 0.25rem; ">
              <b-table
                class="tableU position-relative"
                ref="refBrandNameTagTableU"
                id="brandNameTagTableU"
                :items="fetchGroupsU"
                :fields="tableColumnsU"
                :busy="isBusyU"
                :sort-desc.sync="sortDescU" 
                :sort-by.sync="sortByU"
                :sort-direction='sortDirectionU'
                responsive
                show-empty
                no-border-collapse
                outlined
                head-variant="light"
                table-class="table-font-size"
                empty-text="해당하는 TAG가 없습니다."
                sticky-header="true"
                style="max-height: 550px;"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortByU !== key" src="/caretupdown.png" style="width: 10px; margin-top: -2px;"></b-img>
                    <b-img v-else-if="sortDescU" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>

                <template #cell(rank)="data">
                    <div>{{ data.item.rank }}</div>
                </template>
                <template #cell(tag)="data">
                  <div style="display: flex; align-items: center;">
                    <div v-if="data.item.color == '#FF9F4A'" style="display: inline-block; width: 1rem; height: 1rem; background: #FF9F4A;"></div> 
                    <div v-else-if="data.item.color == '#FF7070'" style="display: inline-block; width: 1rem; height: 1rem; background: #FF7070;"></div> 
                    <div v-else-if="data.item.color == '#FDA8AA'" style="display: inline-block; width: 1rem; height: 1rem; background: #FDA8AA;"></div> 
                    <div v-else-if="data.item.color == '#86C98A'" style="display: inline-block; width: 1rem; height: 1rem; background: #86C98A;"></div> 
                    <div v-else-if="data.item.color == '#887CAF'" style="display: inline-block; width: 1rem; height: 1rem; background: #887CAF;"></div> 
                    <div v-else-if="data.item.color == '#E3A209'" style="display: inline-block; width: 1rem; height: 1rem; background: #E3A209;"></div> 
                    <div v-else-if="data.item.color == '#CB87AF'" style="display: inline-block; width: 1rem; height: 1rem; background: #CB87AF;"></div> 
                    <div v-else-if="data.item.color == '#09D8E3'" style="display: inline-block; width: 1rem; height: 1rem; background: #09D8E3;"></div> 
                    <div v-else-if="data.item.color == '#FFD1AA'" style="display: inline-block; width: 1rem; height: 1rem; background: #FFD1AA;"></div> 
                    <div v-else-if="data.item.color == '#748BA7'" style="display: inline-block; width: 1rem; height: 1rem; background: #748BA7;"></div> 
                    <div v-else-if="data.item.color == '#9675AB'" style="display: inline-block; width: 1rem; height: 1rem; background: #9675AB;"></div> 
                    <div v-else-if="data.item.color == '#0993E3'" style="display: inline-block; width: 1rem; height: 1rem; background: #0993E3;"></div> 
                    <div v-else-if="data.item.color == '#D46A6A'" style="display: inline-block; width: 1rem; height: 1rem; background: #D46A6A;"></div> 
                    <div v-else-if="data.item.color == '#55AA55'" style="display: inline-block; width: 1rem; height: 1rem; background: #55AA55;"></div> 
                    <div v-else-if="data.item.color == '#615192'" style="display: inline-block; width: 1rem; height: 1rem; background: #615192;"></div> 
                    <div v-else-if="data.item.color == '#D4C16A'" style="display: inline-block; width: 1rem; height: 1rem; background: #D4C16A;"></div> 
                    <div v-else-if="data.item.color == '#18516f'" style="display: inline-block; width: 1rem; height: 1rem; background: #18516f;"></div> 
                    <div v-else-if="data.item.color == '#4F608F'" style="display: inline-block; width: 1rem; height: 1rem; background: #4F608F;"></div> 
                    <div v-else-if="data.item.color == '#D4A16A'" style="display: inline-block; width: 1rem; height: 1rem; background: #D4A16A;"></div> 
                    <div v-else-if="data.item.color == '#AA3939'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA3939;"></div> 
                    <div v-else-if="data.item.color == '#2D882D'" style="display: inline-block; width: 1rem; height: 1rem; background: #2D882D;"></div> 
                    <div v-else-if="data.item.color == '#403075'" style="display: inline-block; width: 1rem; height: 1rem; background: #403075;"></div> 
                    <div v-else-if="data.item.color == '#AA9439'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA9439;"></div> 
                    <div v-else-if="data.item.color == '#2E4172'" style="display: inline-block; width: 1rem; height: 1rem; background: #2E4172;"></div> 
                    <div v-else-if="data.item.color == '#AA7239'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA7239;"></div> 
                    <div v-else-if="data.item.color == '#801515'" style="display: inline-block; width: 1rem; height: 1rem; background: #801515;"></div> 
                    <div v-else-if="data.item.color == '#196811'" style="display: inline-block; width: 1rem; height: 1rem; background: #196811;"></div> 
                    <div v-else-if="data.item.color == '#261758'" style="display: inline-block; width: 1rem; height: 1rem; background: #261758;"></div> 
                    <div v-else-if="data.item.color == '#806C15'" style="display: inline-block; width: 1rem; height: 1rem; background: #806C15;"></div> 
                    <div v-else-if="data.item.color == '#162955'" style="display: inline-block; width: 1rem; height: 1rem; background: #162955;"></div> 
                    <div v-else-if="data.item.color == '#804815'" style="display: inline-block; width: 1rem; height: 1rem; background: #804815;"></div> 
                    <div v-else-if="data.item.color == '#550200'" style="display: inline-block; width: 1rem; height: 1rem; background: #550200;"></div> 
                    <div v-else-if="data.item.color == '#034500'" style="display: inline-block; width: 1rem; height: 1rem; background: #034500;"></div> 
                    <div v-else-if="data.item.color == '#13073A'" style="display: inline-block; width: 1rem; height: 1rem; background: #13073A;"></div> 
                    <div v-else-if="data.item.color == '#554600'" style="display: inline-block; width: 1rem; height: 1rem; background: #554600;"></div> 
                    <div v-else-if="data.item.color == '#061539'" style="display: inline-block; width: 1rem; height: 1rem; background: #061539;"></div> 
                    <div v-else-if="data.item.color == '#552700'" style="display: inline-block; width: 1rem; height: 1rem; background: #552700;"></div> 
                    <div v-else-if="data.item.color == '#AA5585'" style="display: inline-block; width: 1rem; height: 1rem; background: #AA5585;"></div> 
                    <div v-else-if="data.item.color == '#B4CB65'" style="display: inline-block; width: 1rem; height: 1rem; background: #B4CB65;"></div> 
                    <div v-else-if="data.item.color == '#724C8F'" style="display: inline-block; width: 1rem; height: 1rem; background: #724C8F;"></div> 
                    <div v-else-if="data.item.color == '#467386'" style="display: inline-block; width: 1rem; height: 1rem; background: #467386;"></div> 
                    <div v-else style="display: inline-block; width: 1rem; height: 1rem; background: red;">{{ data.item.color }} </div> 
                    <div style="display: inline-block; margin-left: 0.3rem;">{{ data.item.tag }}</div>
                  </div>
                </template>
                <template #cell(frequency)="data">
                    <div>{{ data.item.frequency.toLocaleString() }}</div>
                </template>
              </b-table>
            </b-col>
          </b-row>




        </b-col>
      </b-row>
    </b-card>



    <b-card  ref="bntPrintArea2" class="mb-0" style="font-family: 'NanumBarunGothic'; padding: 1.0rem 1.5rem;" no-body>
      <b-row>
        <b-col xl="2" md="2" sm="2">
          <vue-select
            class="select-brand"
            :options="periodList"
            :clearable="false"
            v-model="selectedPeriod"
            placeholder="기간"
          >
          </vue-select>
        </b-col>
        <b-col xl="2" md="2" sm="2">
        </b-col>
        <b-col xl="4" md="4" sm="4" style="margin-left: -2rem;">
          <b-row>
            <b-col>
              <div style="width: 100%; text-align: center;">
                <h2 style="margin-bottom: 0rem;">기간별 검색량 상위 키워드</h2>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: center; color: #6B6B6B; margin-bottom: 0.5rem;">
              {{ this.mapHistory.toUpperCase() }}
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="4" md="4" sm="4">
        </b-col>
      </b-row>
      

      <b-row style="margin-top: 2rem;" align-v="center">
        <b-col xl="1" md="1" sm="1" class="d-flex align-items-center justify-content-center">
          <b-button pill size="sm" style="margin: 8px; width: 30px; height: 50px; padding: 8px; background-color: #4E86FF !important; border-color: #4E86FF !important;" class="d-flex align-items-center justify-content-center" @click="getTableDates(-1)">
            <feather-icon class="arrow" icon="ChevronLeftIcon" size="30"/>
          </b-button>
        </b-col>
        <b-col xl="10" md="10" sm="10">
          <b-row>
            <b-col xl="3" md="3" sm="3">
              <div style="text-align: left; color: #19A0FB;"> 📶 {{ this.tablePeriod1 }}</div>
              <b-table
                class="table1 position-relative"
                ref="refBrandNameTagTable1"
                id="brandNameTagTable1"
                :items="fetchGroups1"
                :fields="tableColumns1"
                :busy="isBusy1"
                :sort-desc.sync="sortDesc1" 
                :sort-by.sync="sortBy1"
                :sort-direction='sortDirection1'
                responsive
                show-empty
                no-border-collapse
                outlined
                head-variant="light"
                hover
                table-class="table-font-size"
                empty-text="해당하는 키워드가 없습니다."
                sticky-header="true"
                style="max-height: 42.8rem; min-height: 42.8rem;"
                selectable
                select-mode="single"
                @row-selected="clickTableRow"
                @row-clicked="onRowClicked('1')"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortBy1 !== key" src="/caretupdown.png" style="width: 10px; margin-top: -2px;"></b-img>
                    <b-img v-else-if="sortDesc1" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col xl="3" md="3" sm="3">
              <div style="text-align: left; color: #19A0FB;"> 📶 {{ this.tablePeriod2 }}</div>
              <b-table
                class="table2 position-relative"
                ref="refBrandNameTagTable2"
                id="brandNameTagTable2"
                :items="fetchGroups2"
                :fields="tableColumns2"
                :busy="isBusy2"
                :sort-desc.sync="sortDesc2" 
                :sort-by.sync="sortBy2"
                :sort-direction='sortDirection2'
                responsive
                show-empty
                no-border-collapse
                outlined
                head-variant="light"
                hover
                table-class="table-font-size"
                empty-text="해당하는 키워드가 없습니다."
                sticky-header="true"
                style="max-height: 42.8rem; min-height: 42.8rem;"
                selectable
                select-mode="single"
                @row-selected="clickTableRow"
                @row-clicked="onRowClicked('2')"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortBy2 !== key" src="/caretupdown.png" style="width: 10px; margin-top: -2px;"></b-img>
                    <b-img v-else-if="sortDesc2" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col xl="3" md="3" sm="3">
              <div style="text-align: left; color: #19A0FB;"> 📶 {{ this.tablePeriod3 }}</div>
              <b-table
                class="table3 position-relative"
                ref="refBrandNameTagTable3"
                id="brandNameTagTable3"
                :items="fetchGroups3"
                :fields="tableColumns3"
                :busy="isBusy3"
                :sort-desc.sync="sortDesc3"
                :sort-by.sync="sortBy3"
                :sort-direction='sortDirection3'
                responsive
                show-empty
                no-border-collapse
                outlined
                head-variant="light"
                hover
                table-class="table-font-size"
                empty-text="해당하는 키워드가 없습니다."
                sticky-header="true"
                style="max-height: 42.8rem; min-height: 42.8rem;"
                selectable
                select-mode="single"
                @row-selected="clickTableRow"
                @row-clicked="onRowClicked('3')"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortBy3 !== key" src="/caretupdown.png" style="width: 10px; margin-top: -2px;"></b-img>
                    <b-img v-else-if="sortDesc3" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
            <b-col xl="3" md="3" sm="3">
              <div style="text-align: left; color: #19A0FB;"> 📶 {{ this.tablePeriod4 }}</div>
              <b-table
                class="table4 position-relative"
                ref="refBrandNameTagTable4"
                id="brandNameTagTable4"
                :items="fetchGroups4"
                :fields="tableColumns4"
                :busy="isBusy4"
                :sort-desc.sync="sortDesc4" 
                :sort-by.sync="sortBy4"
                :sort-direction='sortDirection4'
                responsive
                show-empty
                no-border-collapse
                outlined
                hover
                head-variant="light"
                table-class="table-font-size"
                empty-text="해당하는 키워드가 없습니다."
                sticky-header="true"
                style="max-height: 42.8rem; min-height: 42.8rem;"
                selectable
                select-mode="single"
                @row-selected="clickTableRow"
                @row-clicked="onRowClicked('4')"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortBy4 !== key" src="/caretupdown.png" style="width: 10px; margin-top: -2px;"></b-img>
                    <b-img v-else-if="sortDesc4" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-col>
        <b-col xl="1" md="1" sm="1" class="d-flex align-items-center justify-content-center">
          <!-- <b-button pill size="sm" style="margin: 8px; width: 30px; height: 50px; padding: 8px; background-color: #4E86FF !important; border-color: #4E86FF !important;" class="d-flex align-items-center justify-content-center" @click="setMonthData('next')"> -->
          <b-button pill size="sm" style="margin: 8px; width: 30px; height: 50px; padding: 8px; background-color: #4E86FF !important; border-color: #4E86FF !important;" class="d-flex align-items-center justify-content-center" @click="getTableDates(1)">
            <feather-icon class="arrow" icon="ChevronRightIcon" size="30"/>
          </b-button>
        </b-col>

      </b-row>

      <dialog closedby="any" style="border: solid gray 1.5px; border-radius: 3px;">
        <div class="newsitem" @click="keywordsearch()">
          자세히 보기
          <slot />
        </div>
      </dialog>


    </b-card>

    

    

    <!-- <keyword-search-modal
      ref="keywordSearchModal"
      :searchKeyword="searchKeyword"
    /> -->



  </section>
</template>



<script>
import { 
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BCardText,
    BFormRadio, 
    BFormRadioGroup,
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BFormCheckbox,
    BFormCheckboxGroup,
    BInputGroup,
    BImg,
} from "bootstrap-vue";

import FlatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js'
import 'flatpickr/dist/plugins/monthSelect/style.css'


import BrandNameTagChartBar from "@/views/cis-brandnametag/components/BrandNameTagChartBar.vue";
// import BrandPinChartNet from "@/views/cis-brandpin/components/BrandPinChartNet.vue";
import BrandNameTagChartNet2 from "@/views/cis-brandnametag/components/BrandNameTagChartNet2.vue";

import CisBrandNameTagService from "@/services/cis-brandnametag.service";
import CategoryService from "@/services/category.service";

// import KeywordSearchModal from "@/views/cis-keywordsearch/KeywordSearchModal";

import useAppConfig from "@core/app-config/useAppConfig";

import ExportPDF from "@/components/pdfExport";
import debounce from "lodash";

import * as XLSX from 'xlsx';

import axios from "axios"
import { normalizeRules } from 'vee-validate';

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

export default {
  name: "BrandPin",
  components: {
    FlatPickr,
    BCard,
    BCol,
    BRow,
    BCardBody,
    vSelect,
    BButton,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BFormRadio,
    BFormRadioGroup,
    BTooltip,
    BFormCheckbox,
    BFormCheckboxGroup,
    BInputGroup,
    BImg,

    BrandNameTagChartBar,
    // BrandPinChartNet,
    BrandNameTagChartNet2,

    // KeywordSearchModal,

  },
  data() {
    return {

      elementScroll: 0,
      searchKeyword: '',
      lastClickedMousePos: null,

      tabNum: null,

      clickedRow: '',

      loadedItem: [],
      loadedItemParent: [],

      whichChart: 'net',
      total_row: null,
      gubunsObjects: [
        { type: "subBrand", value: "라인 브랜드"},
        { type: "productName", value: "상품명"}
      ],
      gubuns:['라인 브랜드', '상품명'],


      selectedGubuns: ["라인 브랜드", "상품명"],
      allSelected: true,
      indeterminate: false,


      radioOptions: [
        { text : '속성', value: 'attributes'},
        { text : '라인 브랜드/상품명', value: 'brands'}
      ],
      selectedRadio: 'attributes',

      nodeColors : [
        '#FDA8AA', '#86C98A', '#887CAF', '#E3A209', '#CB87AF', '#09D8E3', '#FFD1AA', '#748BA7', '#9675AB', '#0993E3', '#D46A6A', '#55AA55', '#615192', '#D4C16A', '#18516f', '#4F608F', '#D4A16A', '#AA3939', 
        '#2D882D', '#403075', '#AA9439', '#2E4172', '#AA7239', '#801515', '#196811', '#261758', '#806C15', '#162955', '#804815', '#550200', '#034500', '#13073A', '#554600', '#061539', '#552700', '#AA5585', 
        '#B4CB65', '#18516f', '#724C8F', '#467386'
      ],


      mapHistory: "TOTAL",

      tableColumnsU: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-left w20', tdClass: 'text-center'},
        { key: 'tag', label: 'TAG', sortable: true , thClass: 'text-left'},
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-right', tdClass: 'text-right'},
      ],
      fetchGroupsU: null,
      isBusyU: false,
      sortByU: null,
      sortDescU: false,
      sortDirectionU: 'desc',


      subBrandList: [],
      productList: [],
      cdjContentList: [],
      selectedNode: null,
      selectedNodeParent: null,

      st_dt_list: [],
      en_dt_list: [],

      tablePage: 0,

      tablePeriod1: "2024.07.01 ~ 2024.07.31",
      tableColumns1: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-left w20', tdClass: 'text-center'},
        { key: 'keyword', label: '연관어', sortable: true , thClass: 'text-left'},
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-right', tdClass: 'text-right'},
      ],
      fetchGroups1: null,
      isBusy1: false,
      sortBy1: null,
      sortDesc1: false,
      sortDirection1: 'desc',

      tablePeriod2: "2024.08.01 ~ 2024.08.31",
      tableColumns2: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-left w20', tdClass: 'text-center'},
        { key: 'keyword', label: '연관어', sortable: true , thClass: 'text-left'},
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-right', tdClass: 'text-right'},
      ],
      fetchGroups2: null,
      isBusy2: false,
      sortBy2: null,
      sortDesc2: false,
      sortDirection2: 'desc',

      tablePeriod3: "2024.09.01 ~ 2024.09.30",
      tableColumns3: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-left w20', tdClass: 'text-center'},
        { key: 'keyword', label: '연관어', sortable: true , thClass: 'text-left'},
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-right', tdClass: 'text-right'},
      ],
      fetchGroups3: null,
      isBusy3: false,
      sortBy3: null,
      sortDesc3: false,
      sortDirection3: 'desc',

      tablePeriod4: "2024.10.01 ~ 2024.10.31",
      tableColumns4: [
        { key: 'rank', label: '순위',  sortable: true, thClass: 'text-left w20', tdClass: 'text-center'},
        { key: 'keyword', label: '연관어', sortable: true , thClass: 'text-left'},
        { key: 'frequency', label: '검색량', sortable: true , thClass: 'text-right', tdClass: 'text-right'},
      ],
      fetchGroups4: null,
      isBusy4: false,
      sortBy4: null,
      sortDesc4: false,
      sortDirection4: 'desc',

      
      

      

      isPdfExporting: false,
      isXlsExporting: false,

      selectedChart: "net",

      isBusy: false,
      barChartInit1: false,
      barChartInit2: false,

      selectedDates: [],

      totalFreq1: 0,
      barChartData1: [],
      barChartFreq1: [],
      barChartSub1: [],
      barChartSubTitle1 : [],
      barChartCategory1: [],
      barChartColor1: [],
      totalFreq2: 0,
      barChartData2: [],
      barChartFreq2: [],
      barChartSub2: [],
      barChartSubTitle2 : [],
      barChartCategory2: [],
      height: 0,

      barLoadEnd: false,

      netChartNodes1: [],
      netChartLinks1: [],

      netChartNodes2: [],
      netChartLinks2: [],

      netChartNodesSubBrand1: [], 
      netChartLinksSubBrand1: [],
      netChartNodesProduct1: [],
      netChartLinksProduct1: [],
      netChartNodesPersonAd1: [],
      netChartLinksPersonAd1: [],

      netChartNodesSubBrand2: [],
      netChartLinksSubBrand2: [],
      netChartNodesProduct2: [],
      netChartLinksProduct2: [],
      netChartNodesPersonAd2: [],
      netChartLinksPersonAd2: [],

      firstClassList: [],            
      middleClassList: [],            
      brandList: [],
      periodList: ['월', '주', '일'],

      selectedPeriod: "월",

      selectedFirstClass: "",      
      selectedMiddleClass: "",   
      selectedBrand1: null,
      selectedBrand2: null,

      selectedOptions: [],

      form: {
        monthSelect: []
      },
      configs: {
        monthSelect: {
          mode: "range",
          altFormat: 'Y-m',
          plugins: [
            new monthSelectPlugin({
              shorthand: true,
              dateFormat: "Y-m",
            })
          ],
          locale: {
            rangeSeparator: ' ~ '
          },
          minDate:"2018-01-01",
          maxDate: moment().endOf('month').format('YYYY-MM-DD') // 이번 달 말일로 지정
        }
      },
    };
  },
  computed: {
    check_selectedCategory(){
      return this.$store.getters.getSelectedCategory
    },
    windowSize(){
      console.log('windowSize!!!!!!!!!!!!')
      return {
      width: this.windowWidth,
      height: this.windowHeight
      };
    }
  },
  watch: {
    selectedGubuns(newValue, oldValue) {
        // Handle changes in individual flavour checkboxes
        if (newValue.length === 0) {
          this.indeterminate = false
          this.allSelected = false
        } else if (newValue.length === this.gubuns.length) {
          this.indeterminate = false
          this.allSelected = true
        } else {
          this.indeterminate = true
          this.allSelected = false
        }
    },
    check_selectedCategory(val){
      this.abort(true, 'change category')
      this.selectedOptions = [];
      this.selectedFirstClass = null;
      this.selectedMiddleClass = null;
      this.selectedBrand1 = null;
      this.selectedBrand2 = null;
      this.selectedOptions.push(this.$store.getters.getSelectedCategory)
      this.selectedOptions.push(this.selectedFirstClass)
      this.selectedOptions.push(this.selectedMiddleClass)
      this.selectedOptions.push(this.selectedDates)
      this.setFirstClasses();
      this.runAnalysis()
    },
    selectedFirstClass(){
      this.selectedMiddleClass = null;
      this.selectedBrand1 = null;
      this.selectedBrand2 = null;
      this.selectedOptions.push(this.$store.getters.getSelectedCategory)
      this.selectedOptions.push(this.selectedFirstClass)
      this.selectedOptions.push(this.selectedMiddleClass)
      this.selectedOptions.push(this.selectedDates)
      this.setMiddleClasses();
    },
    selectedMiddleClass(){
      this.selectedBrand1 = null;
      this.selectedBrand2 = null;
      this.selectedOptions.push(this.$store.getters.getSelectedCategory)
      this.selectedOptions.push(this.selectedFirstClass)
      this.selectedOptions.push(this.selectedMiddleClass)
      this.selectedOptions.push(this.selectedDates)
    },
    selectedDates(){
      this.selectedOptions.push(this.$store.getters.getSelectedCategory)
      this.selectedOptions.push(this.selectedFirstClass)
      this.selectedOptions.push(this.selectedMiddleClass)
      this.selectedOptions.push(this.selectedDates)
    },
    // selectedOptions(){
    //   if(this.$store.getters.getSelectedCategory != '9999'){
    //     this.setBrandList();
    //     this.setGubuns();
    //   }
    // },
    selectedBrand1(){
      this.setGubuns();
    },
    selectedRadio(){
      console.log(this.selectedRadio)
      this.setGubuns();
    },
    selectedPeriod(){
      this.getTableDates(0)
    },
    selectedNode(){
      this.getTableDates(0)
    },
  },
  methods: {
    scrollEvents(e) {
      this.hideDialog()
    },

    // onRowClicked(item, index, event) {
      
    //   this.lastClickedMousePos = {
    //     x: event.clientX,
    //     y: event.clientY
    //   };
    //   console.log(this.lastClickedMousePos.x)
    //   console.log(this.lastClickedMousePos.y)

    // },
    onRowClicked(tabNum) {
      this.tabNum = tabNum
    },

    moveScroll(keyword){
      this.$refs.bntPrintArea2.scrollIntoView({})
      setTimeout(() => this.showDialog(keyword), 200);
    },
    showDialog(keyword){
      // 테이블 로우 포지션으로 
      var tableElement = null;
      if(this.tabNum == '1'){
        tableElement = this.$refs.refBrandNameTagTable1.$el;
      }else if(this.tabNum == '2'){
        tableElement = this.$refs.refBrandNameTagTable2.$el;
      }else if(this.tabNum == '3'){
        tableElement = this.$refs.refBrandNameTagTable3.$el;
      }else{
        tableElement = this.$refs.refBrandNameTagTable4.$el;
      }
      const rowElements = tableElement.querySelectorAll('tbody > tr');
      let targetRowElement = null;
      rowElements.forEach(row => {        
        if (row.cells[1].innerText === keyword) {
          targetRowElement = row;
        }
      });
      if (targetRowElement) {
        const rect = targetRowElement.getBoundingClientRect();
        const x = rect.left;
        const y = rect.top;
        console.log(`Selected row XY position: X=${x}, Y=${y}`);
        console.log('-------------------------------------------')
        console.log(`Window Size: W=${window.innerWidth}, H=${window.innerHeight}`);

        this.searchKeyword = keyword
    
        var dialog_ctrl = document.querySelector('dialog');

        var pos_x = x-100
        var pos_y = y-110
        // window height에 따라 위치 변경
        if(window.innerHeight > 1000){
          pos_y = y-(window.innerHeight/5)
        }else if(window.innerHeight <= 1000 && window.innerHeight > 880){
          pos_y = y-(window.innerHeight/8)
        }else if(window.innerHeight <= 880 && window.innerHeight > 860){
          pos_y = y-(window.innerHeight/10)
        }else if(window.innerHeight <= 860 && window.innerHeight > 830){
          pos_y = y-(window.innerHeight/14)
        }else if(window.innerHeight <= 830 && window.innerHeight > 810){
          pos_y = y-(window.innerHeight/18)
        }else if(window.innerHeight <= 810 && window.innerHeight > 800){
          pos_y = y-(window.innerHeight/22)
        }else{
          pos_y = y
        }

        //var pos_y = y-(window.innerHeight/9)

        dialog_ctrl.style.left = (pos_x) + 'px';
        dialog_ctrl.style.top = (pos_y) + 'px';
        
        dialog_ctrl.show()

      }

      // 마우스 포지션으로
      // this.searchKeyword = keyword
    
      // var dialog_ctrl = document.querySelector('dialog');

      // var pos_x = this.lastClickedMousePos.x - 250
      // var pos_y = this.lastClickedMousePos.y - 150

      // console.log(pos_y)

      // dialog_ctrl.style.left = (pos_x) + 'px';
      // dialog_ctrl.style.top = (pos_y) + 'px';
      
      // dialog_ctrl.show()
    },


    hideDialog(){
      var dialog_ctrl = document.querySelector('dialog');
      dialog_ctrl.close()
    },
    keywordsearch(){
      this.$parent.$parent.$children[1].$refs.keywordSearchModal.loadData(2, this.searchKeyword);
      this.$parent.$parent.$children[1].$bvModal.show("keyword-search-modal");
    },
    runAnalysis(){
      if(this.$store.getters.getSelectedCategory != '9999'){
        this.setBrandList();
        this.setGubuns();
      }
    },
    clickTableRow(item){
      if(item.length > 0){
        var keyword = item[0].keyword
        // 테이블 1
        var table = document.getElementById('brandNameTagTable1')
        if(table.rows.length > 2){
          for (var i = 0, row; row = table.rows[i]; i++) {
            if(row.cells[1].innerHTML == keyword){
              row.className += ' b-table-row-selected table-active'
            }else{
              row.className = ''
            }
          }
        }
        // 테이블 2
        var table = document.getElementById('brandNameTagTable2')
        if(table.rows.length > 2){
          for (var i = 0, row; row = table.rows[i]; i++) {
            if(row.cells[1].innerHTML == keyword){
              row.className += ' b-table-row-selected table-active'
            }else{
              row.className = ''
            }
          }
        }
        // 테이블 3
        var table = document.getElementById('brandNameTagTable3')
        if(table.rows.length > 2){
          for (var i = 0, row; row = table.rows[i]; i++) {
            if(row.cells[1].innerHTML == keyword){
              row.className += ' b-table-row-selected table-active'
            }else{
              row.className = ''
            }
          }
        }
        // 테이블 4
        var table = document.getElementById('brandNameTagTable4')
        if(table.rows.length > 2){
          for (var i = 0, row; row = table.rows[i]; i++) {
            if(row.cells[1].innerHTML == keyword){
              row.className += ' b-table-row-selected table-active'
            }else{
              row.className = ''
            }
          }
        }
        this.moveScroll(item[0].keyword)
      }else{
        // 테이블 1
        var table = document.getElementById('brandNameTagTable1')
        for (var i = 0, row; row = table.rows[i]; i++) {
            row.className = ''
        }
        // 테이블 2
        var table = document.getElementById('brandNameTagTable2')
        for (var i = 0, row; row = table.rows[i]; i++) {
            row.className = ''
        }
        // 테이블 3
        var table = document.getElementById('brandNameTagTable3')
        for (var i = 0, row; row = table.rows[i]; i++) {
            row.className = ''
        }
        // 테이블 4
        var table = document.getElementById('brandNameTagTable4')
        for (var i = 0, row; row = table.rows[i]; i++) {
            row.className = ''
        }
      }
      



    },
    toggleAll(checked) {
        this.selectedGubuns = checked ? this.gubuns.slice() : []
    },
    changeChart(chart){
      this.selectedNode = null
      this.whichChart = chart
      var barCol1 = document.getElementById('brandpinBarCol1');
      var netRow1L = document.getElementById('brandpinNetRow1L');

      console.log('--- changeChart ---')
      console.log(chart)

      if(chart == 'net'){
        barCol1.style.visibility = "hidden";
        netRow1L.style.visibility = "visible";
      }else{
        barCol1.style.visibility = "visible";
        netRow1L.style.visibility = "hidden";
      }
    },

    datePickerOnOpen(selectedDates, dateStr, instance) {
      if (document.querySelector(".fp-max-duration-info") == null) {
        var divEl = document.createElement("div"); 
        divEl.setAttribute('class', 'fp-max-duration-info');   
        divEl.setAttribute('align', 'left');   
        divEl.setAttribute('style', 'margin: 2px 10px; font-family: NanumBarunGothic; font-size: 12px; font-weight: 600; color: #17a2b8;');   
        divEl.innerHTML = "&#9888; 분석기간은 최대 3년 입니다.";
        document.querySelector(".flatpickr-calendar").appendChild(divEl);
      }
    },

    datePickerOnChange(selectedDates, dateStr, instance) {
      instance.element.value = dateStr.replace('to', '~')

      var [st_dt, en_dt] = selectedDates;
      
      if (en_dt == null) {
        var newMindate = moment(st_dt).add(-35, 'month')
        var newMaxdate = moment(st_dt).add( 35, 'month')

        if (newMindate.isBefore(this.configs.monthSelect.minDate)) 
          newMindate = moment(this.configs.monthSelect.minDate);

        if (newMaxdate.isAfter(this.configs.monthSelect.maxDate)) 
          newMaxdate = moment(this.configs.monthSelect.maxDate);

        instance.config.minDate = newMindate.toDate()
        instance.config.maxDate = newMaxdate.toDate()
      }
    },

    datepickerCloseHandler(selectedDates, dateStr, instance) {
      var [st_dt, en_dt] = selectedDates;

      if (en_dt) {
        var diff_month = (en_dt.getYear() - st_dt.getYear()) * 12 + (en_dt.getMonth() - st_dt.getMonth() + 1);

        if (diff_month > 36) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "설정 가능한 최대 분석 기간은 3년(36개월)입니다." || "Unknown error",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });

          var curr_dt = new Date()
          var avail_diff_month = (curr_dt.getYear() - st_dt.getYear()) * 12 + (curr_dt.getMonth() - st_dt.getMonth());

          if (avail_diff_month > 35)
            avail_diff_month = 35
          
          en_dt = moment(st_dt).add(avail_diff_month, 'month').toDate()

          this.form.monthSelect = [st_dt, en_dt]
        }
        else
          this.form.monthSelect = selectedDates;

        var st_dt_str = moment(st_dt).format("YYYY-MM")
        var en_dt_str = moment(en_dt).format("YYYY-MM")

        console.log('---------- Close ------------')
        if(this.selectedDates[0] != st_dt_str || this.selectedDates[1] != en_dt_str){
          this.selectedDates = []
          this.selectedDates.push(st_dt_str)
          this.selectedDates.push(en_dt_str)
          this.$store.dispatch('callPeriodSt', { st_dt: st_dt })
          this.$store.dispatch('callPeriodEn', { en_dt: en_dt })
        }
        
      }
      else
        instance.setDate([this.form.monthSelect[0], this.form.monthSelect[1]], true)
    },
    async setFirstClasses() {
      const firstClasses = await CisBrandNameTagService.listFirstClass({ctgSq: this.$store.getters.getSelectedCategory}, source);

      if(firstClasses){
        if (firstClasses.data.success) {
          console.log('firstClasses.data.data')
          console.log(firstClasses.data.data)

          this.firstClassList = firstClasses.data.data;        
        }
      }
      
    },
    async setMiddleClasses() {
      var fcls_sq = null
      if(this.selectedFirstClass != null){
        fcls_sq = this.selectedFirstClass.id
        const middleClasses = await CisBrandNameTagService.listMiddleClass({
          ctgSq: this.$store.getters.getSelectedCategory,
          fclsSq: fcls_sq
          }, source);

        if(middleClasses){
          if (middleClasses.data.success) {
            console.log('middleClasses.data.data')
            console.log(middleClasses.data.data)

            for(const item of middleClasses.data.data) 
              this.middleClassList.push(item.middle)

            var _idx = this.middleClassList.findIndex((element) => element == "기타");

            if (_idx >= 0) {
              this.middleClassList = this.middleClassList.with(_idx, "중분류 없음")
              this.middleClassList.sort()
            }
          }
        }
      }else{
        this.middleClassList = []
      }
      
    },

    async setBrandList(){
      console.log("setBrandList")

      this.brandList = []
      var fistClassList = []
      if(this.selectedFirstClass != null)
        fistClassList.push(this.selectedFirstClass.id)

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'
      if (sel_Middle == '')
        sel_Middle = null
      
      const brandList = await CisBrandNameTagService.listBrand({
        ctgSq: this.$store.getters.getSelectedCategory,
        firstClassList : fistClassList,
        middle : sel_Middle
      }, source);

      if (brandList.data.success) {
        console.log('브랜드 리스트')
        console.log(brandList)

        for(const item of brandList.data.data) 
          this.brandList.push(item.title)
      }
    },
    
    async setGubuns(){
      console.log("setGubuns")
      this.gubunsObjects = []
      this.gubuns = []
      this.selectedGubuns = []

      document.getElementById('loadingGubun').style.visibility = "visible";

      //차트 초기화
      document.getElementById('brandpinNetRow1L').style.visibility = "hidden";
      document.getElementById('brandpinBarCol1').style.visibility = "hidden";
      document.getElementById('loadingStack').style.visibility = "visible";
      this.isBusyU = true;
      this.fetchGroupsU = [];
      this.total_row = null
      this.fetchGroups4 = [];
      this.isBusy4 = true;
      this.tablePeriod4 = "";
      this.fetchGroups3 = [];
      this.isBusy3 = true;
      this.tablePeriod3 = "";
      this.fetchGroups2 = [];
      this.isBusy2 = true;
      this.tablePeriod2 = "";
      this.fetchGroups1 = [];
      this.isBusy1 = true;
      this.tablePeriod1 = "";



      var fcls_sq = null

      if(this.selectedFirstClass != null)
        fcls_sq = this.selectedFirstClass.id
      
      var brand = null

      if(this.selectedBrand1 != null)
        brand = this.selectedBrand1

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'
      if (sel_Middle == '')
        sel_Middle = null

      const response = await CisBrandNameTagService.listGubun({
        startDate : this.selectedDates[0],
        endDate : this.selectedDates[1],
        ctgSq : this.$store.getters.getSelectedCategory,
        fclsSq : fcls_sq,
        brand : brand,
        middle : sel_Middle,
        type : this.selectedRadio
      }, source)

      if (response && response.status === 200) {
        console.log('-- gubun data --')
        console.log(response)

        this.gubunsObjects = response.data.data

        for(const item of response.data.data) {
          this.gubuns.push(item.value)
          this.selectedGubuns.push(item.value)
        }

        document.getElementById('loadingGubun').style.visibility = "hidden";

        this.loadData();
      }


    },

    async loadData(){
      console.log("loadData");

      if(this.whichChart == 'net'){
        document.getElementById('brandpinNetRow1L').style.visibility = "hidden";
      }else{
        document.getElementById('brandpinBarCol1').style.visibility = "hidden";
      }
      document.getElementById('loadingStack').style.visibility = "visible";

      this.loadedItem = []
      this.loadedItemParent = []

      // 차트 초기화
      this.isBusyU = true;
      this.fetchGroupsU = [];
      this.total_row = null

      this.fetchGroups4 = [];
      this.isBusy4 = true;
      this.tablePeriod4 = "";
      this.fetchGroups3 = [];
      this.isBusy3 = true;
      this.tablePeriod3 = "";
      this.fetchGroups2 = [];
      this.isBusy2 = true;
      this.tablePeriod2 = "";
      this.fetchGroups1 = [];
      this.isBusy1 = true;
      this.tablePeriod1 = "";
      
      this.barChartInit1 = false
      this.barLoadEnd = false

      var fcls_sq = null

      if(this.selectedFirstClass != null)
        fcls_sq = this.selectedFirstClass.id
      
      var brand = null

      if(this.selectedBrand1 != null)
        brand = this.selectedBrand1

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      const response = await CisBrandNameTagService.getBrandPinData({
        startDate : this.selectedDates[0],
        endDate : this.selectedDates[1],
        ctgSq : this.$store.getters.getSelectedCategory,
        fclsSq : fcls_sq,
        brand : brand,
        middle : sel_Middle,
        type : this.selectedRadio,
        gubuns : this.selectedGubuns
      }, source);

      if (response && response.status === 200) {
        console.log('-- Bar1 data --')
        console.log(response)

        this.barChartInit1 = true

        // bar chart update
        var sub_brand_cnt = 0
        var product_cnt = 0        
        this.barChartData1 = []
        this.barChartFreq1 = []
        this.barChartSub1 = []
        this.barChartSubTitle1 = []
        this.barChartColor1 = []
        this.barChartCategory1 = []

        if(response.data.data.length > 0)
          this.totalFreq1 = response.data.data[0].total
        else
          this.totalFreq1 = 0        

        var tag_rank = 0
        for(const item of response.data.data) {
          this.loadedItemParent.push(item.subTitle)
          this.loadedItem.push(item.sub)
          var node_color = ''
          if(item.subTitle == '라인 브랜드'){
            node_color = '#FF9F4A'
          }else if(item.subTitle == '상품명'){
            node_color = '#FF7070'
          }else{
            var gubun_idx = this.gubuns.indexOf(item.subTitle)
            node_color = this.nodeColors[gubun_idx]
          }
          this.barChartData1.push(item.freq)
          this.barChartFreq1.push(item.freq)
          this.barChartSub1.push(item.sub)
          this.barChartSubTitle1.push(item.subTitle)
          if(item.subTitle == '라인 브랜드'){
            this.barChartColor1.push('#FF9F4A')
          }else if(item.subTitle == '상품명'){
            this.barChartColor1.push('#FF7070')
          }else{
            var gubun_idx = this.gubuns.indexOf(item.subTitle)
            this.barChartColor1.push(this.nodeColors[gubun_idx])
          }



          this.barChartCategory1.push(item.sub)

          //upper table update
          tag_rank += 1
          this.fetchGroupsU.push({
            rank: tag_rank,
            tag: item.sub,
            frequency: Math.round(item.freq),
            color: node_color
          })
        }

        this.barLoadEnd = true

        if (this.fetchGroupsU.length > 0) {
          this.total_row = this.fetchGroupsU
        }

        this.isBusyU = false;

        // net chart update
        console.log('-- net chart update --')
        var group1_id = ''

        if(brand == null)
          group1_id = '전체'
        else
          group1_id = brand
        
        //////////////////////////////////////////////////////////////////////////
        var node_cnt = 0

        this.netChartNodesSubBrand1 = []
        this.netChartLinksSubBrand1 = []
        this.netChartNodesSubBrand1.push({ id: group1_id, group: 2, freq: 0 })
        
        this.subBrandList = []
        this.productList = []
        this.cdjContentList = []
        this.selectedNode = null

        for(const item of response.data.data) {
          var node_color = ''
          node_cnt += 1
          if(node_cnt <= 30){
            if(item.subTitle == '라인 브랜드'){
              this.subBrandList.push(item.sub)
              node_color = '#FF9F4A'
            }else if(item.subTitle == '상품명'){
              this.productList.push(item.sub)
              node_color = '#FF7070'
            }else{
              this.cdjContentList.push(item.sub)
              var gubun_idx = this.gubuns.indexOf(item.subTitle)
              node_color = this.nodeColors[gubun_idx]
            }


            this.netChartNodesSubBrand1.push({id: item.sub, group: 3, freq: item.freq, gubun: item.subTitle, rank: node_cnt, color: node_color})
            this.netChartLinksSubBrand1.push({ source: group1_id, target: item.sub })
          }

        }

        if(this.whichChart == 'net'){
          document.getElementById('brandpinNetRow1L').style.visibility = "visible";
        }else{
          document.getElementById('brandpinBarCol1').style.visibility = "visible";
        }
        document.getElementById('loadingStack').style.visibility = "hidden";

        this.getTableDates(0)
      }

    },

    changeNode(node){
      console.log('-- changeNode --')
      console.log(node)
      if(node == '0000'){
        this.selectedNode = null
        var table = document.getElementById('brandNameTagTableU')
        for (var i = 0, row; row = table.rows[i]; i++) {
            row.className = ''
        }
      }else{
        this.selectedNode = node
        var table = document.getElementById('brandNameTagTableU')
        for (var i = 0, row; row = table.rows[i]; i++) {
          if(row.cells[1].innerText == node){
            row.className += ' b-table-row-selected table-active'
          }else{
            row.className = ''
          }
        }
        
      }
    },

    async getTableDates(page){
      console.log("getTableDates");
      
      if(page == 0){
        this.tablePage = 0
      }else if(page > 0){
        this.tablePage-=1
      }else{
        this.tablePage+=1
      }

      if(this.tablePage < 0){
        this.$toast({
            component: ToastificationContent,
            props: {
              title: "설정한 기간의 마지막 입니다." || "Unknown error",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });
        this.tablePage = 0
        return
      }
      // this.tablePage = 1

      // 날짜 세팅
      var st_dt = moment(this.selectedDates[0]).startOf('month').format('YYYY-MM-DD')
      var en_dt = moment(this.selectedDates[1]).endOf('month').format('YYYY-MM-DD')
      console.log(st_dt)
      console.log(en_dt)
      console.log(this.selectedPeriod)
      var st_dt4 = ''
      var en_dt4 = ''
      var st_dt3 = ''
      var en_dt3 = ''
      var st_dt2 = ''
      var en_dt2 = ''
      var st_dt1 = ''
      var en_dt1 = ''

      if(this.selectedPeriod == '주'){
        console.log('---- 주간 ----')
        var weeklyDateRanges = this.getWeeklyDates('2018-01-01', en_dt);
        weeklyDateRanges.reverse()
        var st_idx = this.tablePage
        var en_idx = st_idx + 3
        console.log('this.tablePage : ', this.tablePage)
        console.log('st_idx : ', st_idx)
        console.log('en_idx : ', en_idx)
        console.log('weeklyDateRanges.length : ', weeklyDateRanges.length)
        if(en_idx > weeklyDateRanges.length-1){
          this.$toast({
              component: ToastificationContent,
              props: {
                title: "2018년 1월 1일 이전 데이터는 분석하지 않습니다." || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "warning",
              },
            });
          this.tablePage -= 1
          return
        }
        var weekList = []
        for(var i = st_idx; i <= en_idx; i++){
          console.log(weeklyDateRanges[i])
          var dateList = []
          if(weeklyDateRanges[i].length == 1){
            dateList.push(weeklyDateRanges[i][0])
            dateList.push(weeklyDateRanges[i][0])
          }else{
            dateList.push(weeklyDateRanges[i][0])
            dateList.push(weeklyDateRanges[i][weeklyDateRanges[i].length-1])
          }
          weekList.push(dateList)
        }
        console.log('weekList : ', weekList)
        for(let i in weekList){
          if(i==0){
            st_dt4 = weekList[i][0]
            en_dt4 = weekList[i][1]
          }else if(i==1){
            st_dt3 = weekList[i][0]
            en_dt3 = weekList[i][1]
          }else if(i==2){
            st_dt2 = weekList[i][0]
            en_dt2 = weekList[i][1]
          }else{
            st_dt1 = weekList[i][0]
            en_dt1 = weekList[i][1]
          }
        }
      }
      else if(this.selectedPeriod == '월'){
        if(moment(this.selectedDates[1]).add(-1*this.tablePage, 'month').add(-3, 'month').endOf('month').isBefore('2018-01-01')){
          this.$toast({
              component: ToastificationContent,
              props: {
                title: "2018년 1월 1일 이전 데이터는 분석하지 않습니다." || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "warning",
              },
            });
          this.tablePage -= 1
          return
        }
        st_dt4 = moment(this.selectedDates[1]).add(-1*this.tablePage, 'month').startOf('month').format('YYYY-MM-DD')
        en_dt4 = moment(this.selectedDates[1]).add(-1*this.tablePage, 'month').endOf('month').format('YYYY-MM-DD')
        st_dt3 = moment(this.selectedDates[1]).add(-1*this.tablePage, 'month').add(-1, 'month').startOf('month').format('YYYY-MM-DD')
        en_dt3 = moment(this.selectedDates[1]).add(-1*this.tablePage, 'month').add(-1, 'month').endOf('month').format('YYYY-MM-DD')
        st_dt2 = moment(this.selectedDates[1]).add(-1*this.tablePage, 'month').add(-2, 'month').startOf('month').format('YYYY-MM-DD')
        en_dt2 = moment(this.selectedDates[1]).add(-1*this.tablePage, 'month').add(-2, 'month').endOf('month').format('YYYY-MM-DD')
        st_dt1 = moment(this.selectedDates[1]).add(-1*this.tablePage, 'month').add(-3, 'month').startOf('month').format('YYYY-MM-DD')
        en_dt1 = moment(this.selectedDates[1]).add(-1*this.tablePage, 'month').add(-3, 'month').endOf('month').format('YYYY-MM-DD')
      }else{
        if(moment(en_dt).add(-1*this.tablePage, 'day').add(-3, 'day').isBefore('2018-01-01')){
          this.$toast({
              component: ToastificationContent,
              props: {
                title: "2018년 1월 1일 이전 데이터는 분석하지 않습니다." || "Unknown error",
                icon: "AlertCircleIcon",
                variant: "warning",
              },
            });
          this.tablePage -= 1
          return
        }
        st_dt4 = moment(en_dt).add(-1*this.tablePage, 'day').format('YYYY-MM-DD')
        en_dt4 = moment(en_dt).add(-1*this.tablePage, 'day').format('YYYY-MM-DD')
        st_dt3 = moment(en_dt).add(-1*this.tablePage, 'day').add(-1, 'day').format('YYYY-MM-DD')
        en_dt3 = moment(en_dt).add(-1*this.tablePage, 'day').add(-1, 'day').format('YYYY-MM-DD')
        st_dt2 = moment(en_dt).add(-1*this.tablePage, 'day').add(-2, 'day').format('YYYY-MM-DD')
        en_dt2 = moment(en_dt).add(-1*this.tablePage, 'day').add(-2, 'day').format('YYYY-MM-DD')
        st_dt1 = moment(en_dt).add(-1*this.tablePage, 'day').add(-3, 'day').format('YYYY-MM-DD')
        en_dt1 = moment(en_dt).add(-1*this.tablePage, 'day').add(-3, 'day').format('YYYY-MM-DD')
      }

      console.log('st_dt4 : ', st_dt4)
      console.log('en_dt4 : ', en_dt4)
      console.log('st_dt3 : ', st_dt3)
      console.log('en_dt3 : ', en_dt3)
      console.log('st_dt2 : ', st_dt2)
      console.log('en_dt2 : ', en_dt2)
      console.log('st_dt1 : ', st_dt1)
      console.log('en_dt1 : ', en_dt1)
      this.st_dt_list = []
      this.st_dt_list.push(st_dt1)
      this.st_dt_list.push(st_dt2)
      this.st_dt_list.push(st_dt3)
      this.st_dt_list.push(st_dt4)
      this.en_dt_list = []
      this.en_dt_list.push(en_dt1)
      this.en_dt_list.push(en_dt2)
      this.en_dt_list.push(en_dt3)
      this.en_dt_list.push(en_dt4)


      this.loadDataTables('4', st_dt4, en_dt4)
      this.loadDataTables('3', st_dt3, en_dt3)
      this.loadDataTables('2', st_dt2, en_dt2)
      this.loadDataTables('1', st_dt1, en_dt1)
    },

    async loadDataTables(chart_no, st_dt, en_dt){
      console.log("loadDataTables");
      // 차트 초기화
      if(chart_no == '4'){
        this.fetchGroups4 = []
        this.isBusy4 = true
        this.tablePeriod4 = ""
      }else if(chart_no == '3'){
        this.fetchGroups3 = []
        this.isBusy3 = true
        this.tablePeriod3 = ""
      }else if(chart_no == '2'){
        this.fetchGroups2 = []
        this.isBusy2 = true
        this.tablePeriod2 = ""
      }else{
        this.fetchGroups1 = []
        this.isBusy1 = true
        this.tablePeriod1 = ""
      }

      if(this.subBrandList.length == 0 && this.productList.length == 0 && this.cdjContentList.length == 0){
        if(chart_no == '4'){
          this.isBusy4 = false
          this.tablePeriod4 = st_dt+" ~ "+en_dt
        }else if(chart_no == '3'){
          this.isBusy3 = false
          this.tablePeriod3 = st_dt+" ~ "+en_dt
        }else if(chart_no == '2'){
          this.isBusy2 = false
          this.tablePeriod2 = st_dt+" ~ "+en_dt
        }else{
          this.isBusy1 = false
          this.tablePeriod1 = st_dt+" ~ "+en_dt
        }
        return
      }

      // data load
      var fcls_sq = null
      if(this.selectedFirstClass != null)
        fcls_sq = this.selectedFirstClass.id
      
      var brand = null
      if(this.selectedBrand1 != null)
        brand = this.selectedBrand1

      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var response = null

      if(this.selectedNode == null){
        this.mapHistory = 'TOTAL'
        response = await CisBrandNameTagService.getBrandPinDataTable({
          startDate : st_dt,
          endDate : en_dt,
          ctgSq : this.$store.getters.getSelectedCategory,
          fclsSq : fcls_sq,
          brand : brand,
          middle : sel_Middle,
          subBrand : this.subBrandList,
          product : this.productList,
          cdjContent : this.cdjContentList
        }, source);
      }else{
        var map_idx = this.loadedItem.indexOf(this.selectedNode)
        this.mapHistory = this.loadedItemParent[map_idx] + ' > ' + this.selectedNode
        response = await CisBrandNameTagService.getBrandPinDataTableOne({
          startDate : st_dt,
          endDate : en_dt,
          ctgSq : this.$store.getters.getSelectedCategory,
          fclsSq : fcls_sq,
          brand : brand,
          middle : sel_Middle,
          node : this.selectedNode
        }, source);
      }

      

      if (response && response.status === 200) {
        console.log('-- table', chart_no, 'data --')
        console.log(response)

        if(chart_no == '4'){
          this.fetchGroups4 = response.data.data
          this.isBusy4 = false
          this.tablePeriod4 = st_dt+" ~ "+en_dt
        }else if(chart_no == '3'){
          this.fetchGroups3 = response.data.data
          this.isBusy3 = false
          this.tablePeriod3 = st_dt+" ~ "+en_dt
        }else if(chart_no == '2'){
          this.fetchGroups2 = response.data.data
          this.isBusy2 = false
          this.tablePeriod2 = st_dt+" ~ "+en_dt
        }else{
          this.fetchGroups1 = response.data.data
          this.isBusy1 = false
          this.tablePeriod1 = st_dt+" ~ "+en_dt
        }

      }


      


    },


    async onRowSelected(item){
      console.log('onRowSelected', item)
    },


    getWeeklyDates(startDate, endDate) {
      const weeklyDates = [];
      let currentDate = new Date(startDate);

      while (currentDate <= new Date(endDate)) {
        const week = [];
        const dayOfWeek = currentDate.getDay(); // 0: 일요일, 1: 월요일, ...
        const diff = currentDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1); // 일요일 기준, 월요일 기준
        const weekStartDate = new Date(currentDate.setDate(diff));

        for (let i = 0; i < 7; i++) {
          const date = new Date(weekStartDate);
          date.setDate(weekStartDate.getDate() + i);
          if (date <= new Date(endDate) && date >= new Date(startDate)) {
            week.push(moment(date).format('YYYY-MM-DD'));
          }

          if (date > new Date(endDate)) {
              break;
          }

        }
        weeklyDates.push(week);
        currentDate.setDate(currentDate.getDate() + 7 - dayOfWeek + (dayOfWeek === 0 ? 0 : 1)); // 다음 주로 이동
      }
      return weeklyDates;
    },



    //백업
    async loadDataBar1(){
      console.log("loadDataBar1");

      this.barChartData1 = []
      this.barChartFreq1 = []
      this.barChartSub1 = []
      this.barChartSubTitle1 = []
      this.barChartCategory1 = []
      this.barChartInit1 = false

      var fcls_sq = null

      if(this.selectedFirstClass != null)
        fcls_sq = this.selectedFirstClass.id
      
      var brand = null

      if(this.selectedBrand1 != null)
        brand = this.selectedBrand1
      
      const response = await CisBrandNameTagService.getBrandPinDataBar({
        startDate : this.selectedDates[0],
        endDate : this.selectedDates[1],
        ctgSq : this.$store.getters.getSelectedCategory,
        fclsSq : fcls_sq,
        brand : brand
      }, source);

      if (response && response.status === 200) {
        console.log('-- Bar1 data --')
        console.log(response)

        this.barChartInit1 = true

        // bar chart update
        var sub_brand_cnt = 0
        var product_cnt = 0
        var person_ad_cnt = 0
        var sub_brand_total = 0
        var product_total = 0
        var person_ad_total = 0
        this.barChartData1 = []
        this.barChartFreq1 = []
        this.barChartSub1 = []
        this.barChartSubTitle1 = []
        this.barChartCategory1 = []

        if(response.data.data.length > 0)
          this.totalFreq1 = response.data.data[0].total
        else
          this.totalFreq1 = 0        

        for(const item of response.data.data) {
          this.barChartData1.push(item.rate)
          this.barChartFreq1.push(item.freq)
          this.barChartSub1.push(item.sub)
          this.barChartSubTitle1.push(item.subTitle)
          this.barChartCategory1.push(item.keyword)

          if(item.subTitle == 'sub_brand')
            sub_brand_total = item.subTotal
          else if(item.subTitle == 'product')
            product_total = item.subTotal
          else if(item.subTitle == 'person_ad')
            person_ad_total = item.subTotal
        }

        // net chart update
        var group1_id = ''

        if(brand == null)
          group1_id = '전체'
        else
          group1_id = brand
        
        //////////////////////////////////////////////////////////////////////////
        this.netChartNodesSubBrand1 = []
        this.netChartLinksSubBrand1 = []
        this.netChartNodesSubBrand1.push({ id: "라인브랜드", group: 2, freq: sub_brand_total })
        var sub_brand_cnt2 = 0

        this.netChartNodesProduct1 = []
        this.netChartLinksProduct1 = []
        this.netChartNodesProduct1.push({ id: "상품명", group: 2, freq: product_total })
        var product_cnt2 = 0

        this.netChartNodesPersonAd1 = []
        this.netChartLinksPersonAd1 = []
        this.netChartNodesPersonAd1.push({ id: "광고/인물", group: 2, freq: person_ad_total })
        var person_ad_cnt2 = 0

        for(const item of response.data.data) {
          if(item.subTitle == 'sub_brand'){
            sub_brand_cnt2 += 1

            if(sub_brand_cnt2 <= 15){
              this.netChartNodesSubBrand1.push({id: item.keyword, group: 3, freq: item.freq, gubun: 'sub_brand', rank: sub_brand_cnt2})
              this.netChartLinksSubBrand1.push({ source: "라인브랜드", target: item.keyword })
            }
            
          }else if(item.subTitle == 'product'){
            product_cnt2 += 1

            if(product_cnt2 <= 15){
              this.netChartNodesProduct1.push({id: item.keyword, group: 3, freq: item.freq, gubun: 'product', rank: product_cnt2})
              this.netChartLinksProduct1.push({ source: "상품명", target: item.keyword })
            }
          }else if(item.subTitle == 'person_ad'){
            person_ad_cnt2 += 1

            if(person_ad_cnt2 <= 15){
              this.netChartNodesPersonAd1.push({id: item.keyword, group: 3, freq: item.freq, gubun: 'person_ad', rank: person_ad_cnt2})
              this.netChartLinksPersonAd1.push({ source: "광고/인물", target: item.keyword })
            }
          }
        }
      }
    },

    

    getToday() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return year + month + day
    },

    exportToPDF: _.debounce(async function() {
      this.isPdfExporting = true;

      await sleep(1);

      var ret = null;

      
      ret = await ExportPDF.exportToPDF([this.$refs.bntPrintArea1, this.$refs.bntPrintArea2], 'a4', 'l', 'brand_name_tag_' + this.getToday() + '.pdf');
      if (ret) {
        this.$toast({
            component: ToastificationContent,
            props: {
              title: "PDF export complete!!",
              icon: "EditIcon",
              variant: "success",
            },
          });
      }
      else {
        this.$toast({
            component: ToastificationContent,
            props: {
              title: "PDF export fail!!",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });
      }

      this.isPdfExporting = false;
    }, 100),
    
    newSheet4Intro(dataOrigin, category, major, middle, period, serviceName, brand1, type, gubuns) {
      var tmp_sheet = []

      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: 'CONSUMER in SEARCH Ai', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { t: "s", v: "consumerinsearch.com", l: {Target: "https://consumerinsearch.com"}, s: underlineStyle}]);
      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: '데이터 개요', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '중분류: ', t: "s", s: boldStyle }, { v: middle, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '서비스명: ', t: "s", s: boldStyle }, { v: serviceName, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '브랜드1: ', t: "s", s: boldStyle }, { v: brand1, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '타입: ', t: "s", s: boldStyle }, { v: type, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '구분: ', t: "s", s: boldStyle }, { v: gubuns, t: "s", s: boldStyle }]);

      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4TagData(dataOrigin, category, major, middle, period, brand, type, gubuns, columns, data) {
      var tmp_sheet = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '중분류: ', t: "s", s: boldStyle }, { v: middle, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '브랜드: ', t: "s", s: boldStyle }, { v: brand, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '타입: ', t: "s", s: boldStyle }, { v: type, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '구분: ', t: "s", s: boldStyle }, { v: gubuns, t: "s", s: boldStyle }]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', 'TAG'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      };

      tmp_sheet.push(tmp_header);

      // Data
      for (const idx in data) {
        var tmp_row = [];
        tmp_row.push({t: "n", v: Number(idx) + 1, s: stringStyle});    // No.
        tmp_row.push({t: "s", v: data[idx].tag, s: stringStyle});  // TAG
        tmp_row.push({t: "n", v: Number(data[idx].freq), s: intNumStyle});  // 검색량
        tmp_row.push({t: "s", v: data[idx].criteria, s: stringStyle});    // 구분

        tmp_sheet.push(tmp_row)
      }
      
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4KwdData(dataOrigin, category, major, middle, period, brand, type, gubuns, periodType, columns, data) {
      var tmp_sheet = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '대분류: ', t: "s", s: boldStyle }, { v: major, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '중분류: ', t: "s", s: boldStyle }, { v: middle, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '브랜드: ', t: "s", s: boldStyle }, { v: brand, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '타입: ', t: "s", s: boldStyle }, { v: type, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '구분: ', t: "s", s: boldStyle }, { v: gubuns, t: "s", s: boldStyle }]);
      if (periodType == '주')
          tmp_sheet.push([{ v: '기간 설정: ', t: "s", s: boldStyle }, { v: '주간', t: "s", s: boldStyle }]);
        else if (periodType == '월')
          tmp_sheet.push([{ v: '기간 설정: ', t: "s", s: boldStyle }, { v: '월간', t: "s", s: boldStyle }]);
        else
          tmp_sheet.push([{ v: '기간 설정: ', t: "s", s: boldStyle }, { v: '일간', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '*키워드는 최대 100개까지 제공됩니다.', t: "s", s: boldStyle } ]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      };

      tmp_sheet.push(tmp_header);

      // Data
      for (const idx in data) {
        var tmp_row = [];
        tmp_row.push({t: "n", v: Number(idx) + 1, s: stringStyle});    // No.
        tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle});  // 키워드
        tmp_row.push({t: "s", v: data[idx].freq, s: stringStyle});  // 검색량
        tmp_sheet.push(tmp_row)
      }
      
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    autoFit(data) {
      const wsCols = [];

      data.map((item) => {
        Object.keys(item).map((key, index) => {
          let text = item[key];
          let maxWidth;

          switch(typeof text) {
            case 'number':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                else
                  maxWidth = 10;
              }
              else
                maxWidth = text !== null ? 10 : 0;
                         
              break;
            case 'object':
              if (wsCols[index]) {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                  else
                    maxWidth = wsCols[index].width < text['v'].length * 1.5 ? text['v'].length * 1.5 : wsCols[index].width;
                }
                else
                  maxWidth = wsCols[index].width;
              }
              else {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = text['v'] !== null ? 10 : 0;
                  else
                    maxWidth = text['v'] !== null ? text['v'].length * 1.5 : 0;
                }
                else
                    maxWidth = 0;
              }

              break;
            case 'string':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width < text.length * 1.5 ? text.length * 1.5 : wsCols[index].width;
                else 
                  maxWidth = wsCols[index].width;
              }
              else 
                maxWidth = text !== null ? text.length * 1.5 : 0;
               
              break;
          }

          wsCols[index] = {width : maxWidth}
        })
      })

      for (var index in wsCols)
        wsCols[index].width = wsCols[index].width === 0 ? 10 : wsCols[index].width * 1.5;

      return wsCols
    },

    exportToExcel: _.debounce(async function() {
      const XLSX = require("xlsx-js-style");

      this.isXlsExporting = true;

      await sleep(1);

      try {
        var st_dt_str = moment(this.form.monthSelect[0]).format("YYYY-MM")
        var en_dt_str = moment(this.form.monthSelect[1]).format("YYYY-MM")

        const dataOrigin = 'NAVER';
        var category = 'Unknown';

        const catServResp = await CategoryService.getOneCategory(this.$store.getters.getSelectedCategory, source);

        if (catServResp.data.success)
          category = catServResp.data.data.title

        const period = st_dt_str + ' ~ ' + en_dt_str;

        var major = '전체';
        var middle = '전체';
        var brand1 = '전체';
        var type = this.selectedRadio;
        var gubuns = '';

        if (this.selectedFirstClass != null && this.selectedFirstClass.title.length > 0)
          major = this.selectedFirstClass.title;

        if (this.selectedMiddleClass != null)
          middle = this.selectedMiddleClass;

        if (this.selectedBrand1 != null && this.selectedBrand1.length > 0)
          brand1 = this.selectedBrand1;

        if (this.selectedGubuns != null && this.selectedGubuns.length > 0)
          gubuns = this.selectedGubuns;

        const workbook = XLSX.utils.book_new()	// 엑셀 생성

        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Intro(dataOrigin, category, major, middle, period, 'BRAND NAME TAG', brand1, type, gubuns), 
                                     '데이터 개요') 

        var fcls_sq = null
        
        if(this.selectedFirstClass != null)
          fcls_sq = this.selectedFirstClass.id
        
        var brand_list = [brand1 == '전체' ? null : brand1];

        var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

        if (sel_Middle == '중분류 없음')
          sel_Middle = '기타'

        // tag
        const tagResp = await CisBrandNameTagService.getBrandPinDataExp({
          startDate : this.selectedDates[0],
          endDate : this.selectedDates[1],
          ctgSq : this.$store.getters.getSelectedCategory,
          fclsSq : fcls_sq,
          brand : brand_list[0],
          middle : sel_Middle,
          type : this.selectedRadio,
          gubuns : this.selectedGubuns
        }, source);
        
        if (tagResp && tagResp.status === 200) {
            var brdTags = [];
            for(const item of tagResp.data.data) {
              brdTags.push({
                tag: item.sub,
                freq: item.freq,
                criteria: item.subTitle
              });     
            }
            var brand = brand_list[0] === null ? '전체' : brand_list[0];
            XLSX.utils.book_append_sheet(workbook, 
                                         this.newSheet4TagData(dataOrigin, category, major, middle, period, brand, type, gubuns, ['검색량', '구분'], brdTags), 
                                         'TAG 순위 및 검색량')
          }


          // keyword
          var periodType = this.selectedPeriod;
          var node = '전체'
          if (this.selectedNode != null)
            node = this.selectedNode;

          var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

          if (sel_Middle == '중분류 없음')
            sel_Middle = '기타'

          for (const idx in this.st_dt_list) {
            var kwdResp = null
            if(this.selectedNode == null){
              kwdResp = await CisBrandNameTagService.getBrandPinDataTableExp({
                startDate : this.st_dt_list[idx],
                endDate : this.en_dt_list[idx],
                ctgSq : this.$store.getters.getSelectedCategory,
                fclsSq : fcls_sq,
                brand : brand_list[0],
                middle : sel_Middle,
                subBrand : this.subBrandList,
                product : this.productList,
                cdjContent : this.cdjContentList
              }, source);
            }else{
              kwdResp = await CisBrandNameTagService.getBrandPinDataTableOneExp({
                startDate : this.st_dt_list[idx],
                endDate : this.en_dt_list[idx],
                ctgSq : this.$store.getters.getSelectedCategory,
                fclsSq : fcls_sq,
                brand : brand_list[0],
                middle : sel_Middle,
                node : this.selectedNode
              }, source);
            }

            if (kwdResp && kwdResp.status === 200) {
              var brdKeds = [];
              for(const item of kwdResp.data.data) {
                brdKeds.push({
                  keyword: item.keyword,
                  freq: item.frequency,
                });     
              }
              var brand = brand_list[0] === null ? '전체' : brand_list[0];
              XLSX.utils.book_append_sheet(workbook, 
                                          this.newSheet4KwdData(dataOrigin, category, major, middle, period, brand, type, gubuns, periodType, ['검색량'], brdKeds), 
                                          this.st_dt_list[idx] + '~' + this.en_dt_list[idx] + '키워드 검색량')
            }

          }


        XLSX.writeFile(workbook, 'brand_name_tag_' + this.getToday() + '.xlsx')	// 엑셀 다운로드

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export complete!!",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export fail!!",
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        });
      }

      this.isXlsExporting = false;
    }, 100),

    abort(isReset, message) {
      // cancel the request
      source.cancel(message);

      if (isReset)
        source = cancelToken.source();
    },
  },

  mounted(){
    console.log('----- mounted -----')

    document.addEventListener('scroll', this.scrollEvents, true);

    console.log(document.getElementById('chartCol').offsetWidth)
    var charColWidth = document.getElementById('chartCol').offsetWidth
    var containerWidth = charColWidth - 30


    console.log(document.getElementById('brandpinBarCol1').getElementsByClassName('graphic-container')[0])
    document.getElementById('brandpinBarCol1').getElementsByClassName('graphic-container')[0].style.width = containerWidth.toString()+'px'
    console.log(document.getElementById('brandpinBarCol1').getElementsByClassName('graphic-container')[0])

    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, 200);

    this.runAnalysis()

  },

  destroyed() {
    console.log('----- destroyed -----')
    
    this.abort(false, 'destoryed')
  },

  async created() {
    console.log('----- create -----')

    this.abort(true, 'created')

    this.$store.dispatch('callCISMenu', { cisMenu: 'brandnametag' })

    this.selectedFirstClass = null;
    this.selectedBrand1 = null;
    this.selectedBrand2 = null;
    this.selectedOptions.push(this.$store.getters.getSelectedCategory)
    this.selectedOptions.push(this.selectedFirstClass)
    this.selectedOptions.push(this.selectedDates)
    this.setFirstClasses();

    var st_dt = this.$store.getters.getSelectedPeriodSt
    var en_dt = this.$store.getters.getSelectedPeriodEn

    if (st_dt.length == 0 || en_dt.length == 0) {
      en_dt = moment().add(-2, 'days').toDate() // 데이터 업데이트 시점을 고려
      st_dt = new Date(en_dt)

      st_dt.setMonth(en_dt.getMonth() - 11)
    }

    this.form.monthSelect = [st_dt, en_dt]

    var st_dt_str = moment(st_dt).format("YYYY-MM")
    var en_dt_str = moment(en_dt).format("YYYY-MM")

    this.selectedDates.push(st_dt_str)
    this.selectedDates.push(en_dt_str) 
  },
};

</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.newsitem {
  display: block;
  width: 100%;
  padding: 2px 10px;
  transition: 0.1s;
  position: relative;
  color: #3c3c3b;
  cursor: pointer;
  font-size: 12px;
  line-height: 20px;
  font-weight: 600;
  font-family: NanumBarunGothic !important;
  text-align: right;
  white-space: nowrap;
  border-radius: 3px;
}

.newsitem:hover {
  background-color: #1951DC;
  color: #f0f0f0;
  transition: 0.1s;
}

.flat-picker {
  width: 263px;
}


#brandpinBarCol1 .apexcharts-canvas .apexcharts-text, #brandpinBarCol1 .apexcharts-canvas .apexcharts-tooltip-text, #brandpinBarCol1 .apexcharts-canvas .apexcharts-datalabel-label, #brandpinBarCol1 .apexcharts-canvas .apexcharts-datalabel 
{
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
    filter: none;
}

#brandpinBarCol1 .graphic-container
{
  min-height: 600px;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
}

.major-class .vs__dropdown-menu,
.middle-class .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}

.major-class .vs__dropdown-toggle,
.middle-class .vs__dropdown-toggle 
{
  border: 2px solid #d8d6de;
}

.major-class .vs__search,
.middle-class .vs__search,
.major-class .vs__selected,
.middle-class .vs__selected 
{
  height: 20px;
  margin-top: 4px !important;
}

.first-class .vs__dropdown-menu,
.middle-class .vs__dropdown-menu,
.select-brand .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}


.mb-1 .sticky-top{
  align-self: flex-start;
}


.chart-radio .btn {
  display: block;
}

.chart-radio.btn.btn-secondary {
  background-color: #4E86FF !important;
  border-color: #4E86FF !important;
  box-shadow: none;
}

.chart-radio.btn.btn-secondary.active {
  background-color: #1951dc !important;
  border-color: #1c5cff !important;
  box-shadow: 0 6px 30px -6px #002896;
  font-weight: 600;
  font-size: 1.3rem;
}

.tooltip-inner {
  color: #333;
  background: #fff;
  border: 1px solid #F2F2F2;
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  filter: none;
  box-shadow: 1px 1px 1px #F2F2F2;
  font-weight: bold;
}

.sideMenu {
  background-color: #fff;
  border: 1px solid #d8d6de;
  padding: 10px;
  margin-top: 0.5rem;
  height: 100%;
  max-height: 540px;
  // overflow-y: auto;
  // overflow-x: hidden;
}

.sideMenuInner {
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 440px;
  max-height: 440px;
}

.custom-checkbox .custom-control-label {
    font-size: 1rem;
    position: static;
}

#gubuns > div {
  margin-top: 0.5rem;
}








/* Hide default icon */
.tableU .table.b-table > thead > tr > th,
.tableU .table.b-table > tfoot > tr > td,
.table1 .table.b-table > thead > tr > th,
.table1 .table.b-table > tfoot > tr > td,
.table2 .table.b-table > thead > tr > th,
.table2 .table.b-table > tfoot > tr > td,
.table3 .table.b-table > thead > tr > th,
.table3 .table.b-table > tfoot > tr > td,
.table4 .table.b-table > thead > tr > th,
.table4 .table.b-table > tfoot > tr > td {
  background-image: none !important;
  vertical-align: middle !important;
  padding: 0.75rem 0.5rem;
}

.tableU .table-font-size, 
.table1 .table-font-size, 
.table2 .table-font-size,
.table3 .table-font-size, 
.table4 .table-font-size
 {
  font-size: 12px;
  font-weight: 600;
}

.tableU .b-table thead th.w20{
  width: 20%;
}






#gubunTotal:disabled:checked ~ .custom-control-label::before,
#gubunTotal:checked ~ .custom-control-label::before,
#gubunTotal:active ~ .custom-control-label::before
{
  background-color: $primary;
  border-color: $primary;
}

#gubunTotal ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: $primary;
  border-width: 4px;
  border-radius: 4px;
}


#gubuns .custom-control-input:disabled:checked ~ .custom-control-label::before,
#gubuns .custom-control-input:checked ~ .custom-control-label::before,
#gubuns .custom-control-input:active ~ .custom-control-label::before
{
  background-color: red;
  border-color: red;
}

#gubuns .custom-control-input ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: green;
  border-width: 4px;
  border-radius: 4px;
}


.arrow{
  width: 30px;
  height: 30px;
  stroke: currentColor;
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  fill: none;
}



#spinner {
  margin: calc(50% - 150px) auto;
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
  border-top-color: #1951DC;
  border-radius: 100%;
  display: none;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  100%
  {
    transform: rotate(360deg);
  }
}












////////////////////////////////////////////////////
/// 
/// checkbox styling
/// 
/////////////////////////////////////////////////////
#subBrand:disabled:checked ~ .custom-control-label::before,
#subBrand:checked ~ .custom-control-label::before,
#subBrand:active ~ .custom-control-label::before
{
  background-color: #FFB777;
  border-color: #FFB777;
}
#subBrand ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #FFB777;
  border-width: 4px;
  border-radius: 4px;
}


#productName:disabled:checked ~ .custom-control-label::before,
#productName:checked ~ .custom-control-label::before,
#productName:active ~ .custom-control-label::before
{
  background-color: #FF7070;
  border-color: #FF7070;
}
#productName ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #FF7070;
  border-width: 4px;
  border-radius: 4px;
}

///////////////////////////////////////////////////////////////////////////////

#attr00:disabled:checked ~ .custom-control-label::before,
#attr00:checked ~ .custom-control-label::before,
#attr00:active ~ .custom-control-label::before
{
  background-color: #FDA8AA;
  border-color: #FDA8AA;
}
#attr00 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #FDA8AA;
  border-width: 4px;
  border-radius: 4px;
}

#attr01:disabled:checked ~ .custom-control-label::before,
#attr01:checked ~ .custom-control-label::before,
#attr01:active ~ .custom-control-label::before
{
  background-color: #86C98A;
  border-color: #86C98A;
}
#attr01 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #86C98A;
  border-width: 4px;
  border-radius: 4px;
}

#attr02:disabled:checked ~ .custom-control-label::before,
#attr02:checked ~ .custom-control-label::before,
#attr02:active ~ .custom-control-label::before
{
  background-color: #887CAF;
  border-color: #887CAF;
}
#attr02 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #887CAF;
  border-width: 4px;
  border-radius: 4px;
}

#attr03:disabled:checked ~ .custom-control-label::before,
#attr03:checked ~ .custom-control-label::before,
#attr03:active ~ .custom-control-label::before
{
  background-color: #E3A209 ;
  border-color: #E3A209 ;
}
#attr03 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #E3A209 ;
  border-width: 4px;
  border-radius: 4px;
}

#attr04:disabled:checked ~ .custom-control-label::before,
#attr04:checked ~ .custom-control-label::before,
#attr04:active ~ .custom-control-label::before
{
  background-color: #CB87AF  ;
  border-color: #CB87AF  ;
}
#attr04 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #CB87AF  ;
  border-width: 4px;
  border-radius: 4px;
}

#attr05:disabled:checked ~ .custom-control-label::before,
#attr05:checked ~ .custom-control-label::before,
#attr05:active ~ .custom-control-label::before
{
  background-color: #09D8E3  ;
  border-color: #09D8E3  ;
}
#attr05 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #09D8E3  ;
  border-width: 4px;
  border-radius: 4px;
}

#attr06:disabled:checked ~ .custom-control-label::before,
#attr06:checked ~ .custom-control-label::before,
#attr06:active ~ .custom-control-label::before
{
  background-color: #FFD1AA  ;
  border-color: #FFD1AA  ;
}
#attr06 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #FFD1AA  ;
  border-width: 4px;
  border-radius: 4px;
}

#attr07:disabled:checked ~ .custom-control-label::before,
#attr07:checked ~ .custom-control-label::before,
#attr07:active ~ .custom-control-label::before
{
  background-color: #748BA7   ;
  border-color: #748BA7   ;
}
#attr07 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #748BA7   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr08:disabled:checked ~ .custom-control-label::before,
#attr08:checked ~ .custom-control-label::before,
#attr08:active ~ .custom-control-label::before
{
  background-color: #9675AB   ;
  border-color: #9675AB   ;
}
#attr08 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #9675AB   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr09:disabled:checked ~ .custom-control-label::before,
#attr09:checked ~ .custom-control-label::before,
#attr09:active ~ .custom-control-label::before
{
  background-color: #0993E3   ;
  border-color: #0993E3   ;
}
#attr09 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #0993E3   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr10:disabled:checked ~ .custom-control-label::before,
#attr10:checked ~ .custom-control-label::before,
#attr10:active ~ .custom-control-label::before
{
  background-color: #D46A6A   ;
  border-color: #D46A6A   ;
}
#attr10 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #D46A6A   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr11:disabled:checked ~ .custom-control-label::before,
#attr11:checked ~ .custom-control-label::before,
#attr11:active ~ .custom-control-label::before
{
  background-color: #55AA55   ;
  border-color: #55AA55   ;
}
#attr11 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #55AA55   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr12:disabled:checked ~ .custom-control-label::before,
#attr12:checked ~ .custom-control-label::before,
#attr12:active ~ .custom-control-label::before
{
  background-color: #615192   ;
  border-color: #615192   ;
}
#attr12 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #615192   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr13:disabled:checked ~ .custom-control-label::before,
#attr13:checked ~ .custom-control-label::before,
#attr13:active ~ .custom-control-label::before
{
  background-color: #D4C16A   ;
  border-color: #D4C16A   ;
}
#attr13 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #D4C16A   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr14:disabled:checked ~ .custom-control-label::before,
#attr14:checked ~ .custom-control-label::before,
#attr14:active ~ .custom-control-label::before
{
  background-color: #18516f   ;
  border-color: #18516f   ;
}
#attr14 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #18516f   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr15:disabled:checked ~ .custom-control-label::before,
#attr15:checked ~ .custom-control-label::before,
#attr15:active ~ .custom-control-label::before
{
  background-color: #4F608F   ;
  border-color: #4F608F   ;
}
#attr15 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #4F608F   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr16:disabled:checked ~ .custom-control-label::before,
#attr16:checked ~ .custom-control-label::before,
#attr16:active ~ .custom-control-label::before
{
  background-color: #D4A16A   ;
  border-color: #D4A16A   ;
}
#attr16 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #D4A16A   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr17:disabled:checked ~ .custom-control-label::before,
#attr17:checked ~ .custom-control-label::before,
#attr17:active ~ .custom-control-label::before
{
  background-color: #AA3939   ;
  border-color: #AA3939   ;
}
#attr17 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #AA3939   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr18:disabled:checked ~ .custom-control-label::before,
#attr18:checked ~ .custom-control-label::before,
#attr18:active ~ .custom-control-label::before
{
  background-color: #2D882D   ;
  border-color: #2D882D   ;
}
#attr18 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #2D882D   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr19:disabled:checked ~ .custom-control-label::before,
#attr19:checked ~ .custom-control-label::before,
#attr19:active ~ .custom-control-label::before
{
  background-color: #403075   ;
  border-color: #403075   ;
}
#attr19 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #403075   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr20:disabled:checked ~ .custom-control-label::before,
#attr20:checked ~ .custom-control-label::before,
#attr20:active ~ .custom-control-label::before
{
  background-color: #AA9439   ;
  border-color: #AA9439   ;
}
#attr20 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #AA9439   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr21:disabled:checked ~ .custom-control-label::before,
#attr21:checked ~ .custom-control-label::before,
#attr21:active ~ .custom-control-label::before
{
  background-color: #2E4172   ;
  border-color: #2E4172   ;
}
#attr21 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #2E4172   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr22:disabled:checked ~ .custom-control-label::before,
#attr22:checked ~ .custom-control-label::before,
#attr22:active ~ .custom-control-label::before
{
  background-color: #AA7239   ;
  border-color: #AA7239   ;
}
#attr22 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #AA7239   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr23:disabled:checked ~ .custom-control-label::before,
#attr23:checked ~ .custom-control-label::before,
#attr23:active ~ .custom-control-label::before
{
  background-color: #801515   ;
  border-color: #801515   ;
}
#attr23 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #801515   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr24:disabled:checked ~ .custom-control-label::before,
#attr24:checked ~ .custom-control-label::before,
#attr24:active ~ .custom-control-label::before
{
  background-color: #196811   ;
  border-color: #196811   ;
}
#attr24 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #196811   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr25:disabled:checked ~ .custom-control-label::before,
#attr25:checked ~ .custom-control-label::before,
#attr25:active ~ .custom-control-label::before
{
  background-color: #261758   ;
  border-color: #261758   ;
}
#attr25 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #261758   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr26:disabled:checked ~ .custom-control-label::before,
#attr26:checked ~ .custom-control-label::before,
#attr26:active ~ .custom-control-label::before
{
  background-color: #806C15   ;
  border-color: #806C15   ;
}
#attr26 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #806C15   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr27:disabled:checked ~ .custom-control-label::before,
#attr27:checked ~ .custom-control-label::before,
#attr27:active ~ .custom-control-label::before
{
  background-color: #162955   ;
  border-color: #162955   ;
}
#attr27 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #162955   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr28:disabled:checked ~ .custom-control-label::before,
#attr28:checked ~ .custom-control-label::before,
#attr28:active ~ .custom-control-label::before
{
  background-color: #804815   ;
  border-color: #804815   ;
}
#attr28 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #804815   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr29:disabled:checked ~ .custom-control-label::before,
#attr29:checked ~ .custom-control-label::before,
#attr29:active ~ .custom-control-label::before
{
  background-color: #550200   ;
  border-color: #550200   ;
}
#attr29 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #550200   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr30:disabled:checked ~ .custom-control-label::before,
#attr30:checked ~ .custom-control-label::before,
#attr30:active ~ .custom-control-label::before
{
  background-color: #034500   ;
  border-color: #034500   ;
}
#attr30 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #034500   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr31:disabled:checked ~ .custom-control-label::before,
#attr31:checked ~ .custom-control-label::before,
#attr31:active ~ .custom-control-label::before
{
  background-color: #13073A   ;
  border-color: #13073A   ;
}
#attr31 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #13073A   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr32:disabled:checked ~ .custom-control-label::before,
#attr32:checked ~ .custom-control-label::before,
#attr32:active ~ .custom-control-label::before
{
  background-color: #554600   ;
  border-color: #554600   ;
}
#attr32 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #554600   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr33:disabled:checked ~ .custom-control-label::before,
#attr33:checked ~ .custom-control-label::before,
#attr33:active ~ .custom-control-label::before
{
  background-color: #061539   ;
  border-color: #061539   ;
}
#attr33 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #061539   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr34:disabled:checked ~ .custom-control-label::before,
#attr34:checked ~ .custom-control-label::before,
#attr34:active ~ .custom-control-label::before
{
  background-color: #552700   ;
  border-color: #552700   ;
}
#attr34 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #552700   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr35:disabled:checked ~ .custom-control-label::before,
#attr35:checked ~ .custom-control-label::before,
#attr35:active ~ .custom-control-label::before
{
  background-color: #AA5585   ;
  border-color: #AA5585   ;
}
#attr35 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #AA5585   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr36:disabled:checked ~ .custom-control-label::before,
#attr36:checked ~ .custom-control-label::before,
#attr36:active ~ .custom-control-label::before
{
  background-color: #B4CB65   ;
  border-color: #B4CB65   ;
}
#attr36 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #B4CB65   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr37:disabled:checked ~ .custom-control-label::before,
#attr37:checked ~ .custom-control-label::before,
#attr37:active ~ .custom-control-label::before
{
  background-color: #18516f   ;
  border-color: #18516f   ;
}
#attr37 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #18516f   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr38:disabled:checked ~ .custom-control-label::before,
#attr38:checked ~ .custom-control-label::before,
#attr38:active ~ .custom-control-label::before
{
  background-color: #724C8F   ;
  border-color: #724C8F   ;
}
#attr38 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #724C8F   ;
  border-width: 4px;
  border-radius: 4px;
}

#attr39:disabled:checked ~ .custom-control-label::before,
#attr39:checked ~ .custom-control-label::before,
#attr39:active ~ .custom-control-label::before
{
  background-color: #467386   ;
  border-color: #467386   ;
}
#attr39 ~ .custom-control-label::before
{
  background-color: #fff;
  border-color: #467386   ;
  border-width: 4px;
  border-radius: 4px;
}




#brandNameTagTableU > tbody > .table-active > td,
#brandNameTagTable1 > tbody > .table-active > td,
#brandNameTagTable2 > tbody > .table-active > td,
#brandNameTagTable3 > tbody > .table-active > td,
#brandNameTagTable4 > tbody > .table-active > td
{
    // background-color: #f6f6f9;
    // background-color: #D7D7D9;
    background-color: #D4EEFE;
}


</style>
